module.exports = __webpack_public_path__ + "img/link-externo.bf5f929e.svg";